<template>
  <div>
    <b-modal id="success" hide-header hide-footer body-text-variant="dark">
      <template class="bg-success" #modal-title>
        Info
      </template>
      <div class="d-block text-center p-4">
        <h3>Saved Succesfully</h3>
      </div>
      <b-button variant="primary" class="mt-3 px-4 float-right" @click="$bvModal.hide('success')">OK</b-button>
    </b-modal>
    <div class="page-head">
      <div>
        <h3>Workshop</h3>
        <p class="page-head-sub">Parts taken out for workshop jobs</p>
      </div>
    </div>
    <div class="row form-card mx-0 pb-3">
      <div class="w-100 text-left">
        <div class="col-3 d-inline-block">
          <label for="sku">SKU</label>
          <input v-model="newVirtual.sku" class="w-100 form-control" type="text" id="sku" required>
        </div>
        <div class="col-2 d-inline-block">
          <label for="ulazna">Entry Price</label>
          <input v-model.number="newVirtual.nabavna" class="w-100 form-control" type="number" inputmode="decimal" id="ulazna" required>
        </div>
        <div class="col-2 d-inline-block">
          <label for="izlazna">Price</label>
          <input v-model.number="newVirtual.prodajna" class="w-100 form-control" type="number" inputmode="decimal" id="izlazna" required>
        </div>
        <div class="col-1 d-inline-block">
          <label for="kolicina">Quantity</label>
          <input v-model.number="newVirtual.qtt" class="w-100 form-control" type="number" id="kolicina" required>
        </div>
        <div class="col-2 d-inline-block">
          <button @click="addVirtual" class="w-100 btn btn-primary btn-block"><b-icon-plus class="mr-1"></b-icon-plus>Save</button>
        </div>
        <div v-if="user && user.admin" class="col-2 d-inline-block">
          <button v-if="loading" disabled class="btn btn-secondary btn-block"><b-icon class="text-dark" icon="arrow-clockwise" animation="spin" font-scale="1"></b-icon></button>
          <button @click="sellAllVirtuals" v-else class="btn btn-block btn-success">Sell all</button>
        </div>
        <div v-else class="col-2 d-inline-block"><span></span></div>
      </div>
    </div>
    <div class="row mx-0">
      <div v-if="virtuals.length" class="w-100 mt-4">
        <table class="table">
          <thead>
          <tr class="align-middle">
            <th scope="col">#</th>
            <th scope="col">SKU</th>
            <th scope="col">Factory Num</th>
            <th scope="col">Entry Price</th>
            <th scope="col">Price</th>
            <th scope="col">Quantity</th>
            <th scope="col">Date</th>
            <th scope="col" class="text-center">Return</th>
            <th v-if="user && user.admin" scope="col" class="text-center">Sell</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(v, i) of virtuals" v-bind:key="v._id">
            <th class="align-middle" scope="row">{{i + 1}}</th>
            <th class="align-middle" scope="row">{{v.sku}}</th>
            <th class="align-middle" scope="row">{{v.num}}</th>
            <td class="align-middle">{{v.nabavna.toLocaleString('en')}}kr</td>
            <td class="align-middle">{{v.prodajna.toLocaleString('en')}}kr</td>
            <td class="align-middle">{{v.qtt}} kom</td>
            <td class="align-middle">{{moment(v.addedAt).format('DD.MM.YYYY')}}</td>
            <td class="text-center">
              <b-button @click="returnVirtual(v)" size="sm" variant="outline-secondary" v-b-tooltip.hover="'Return to stock'">
                <b-icon-arrow-bar-left></b-icon-arrow-bar-left>
              </b-button>
            </td>
            <td v-if="user && user.admin" class="text-center">
              <b-button @click="sellVirtual(v)" size="sm" variant="outline-success" v-b-tooltip.hover="'Sell'">
                <b-icon-arrow-bar-right></b-icon-arrow-bar-right>
              </b-button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="stat-grid">
      <div class="stat-tile accent">
        <p class="stat-label">Total order value</p>
        <p class="stat-value">{{totalPrice.toFixed(2).toLocaleString('en')}} kr</p>
      </div>
      <div class="stat-tile">
        <p class="stat-label">Total pieces</p>
        <p class="stat-value">{{totalCount}}</p>
      </div>
    </div>

  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';

import fixed from '../fixed';

export default {
  data: () => ({
    virtuals: [],
    newVirtual: {},
    totalCount: 0,
    totalPrice: 0,
    loading: false,
    user: null,
    moment,
  }),
  created() {
    this.user = JSON.parse(localStorage.getItem('user'));
  },
  async mounted() {
    await this.getVirtuals();
  },
  methods: {
    async getVirtuals() {
      this.totalCount = 0;
      this.totalPrice = 0;

      try {
        const { data } = await axios.get(
          `${fixed.API_URL}/admin/all-virtuals`,
          { withCredentials: true },
        );
        this.virtuals = data;
        if (data.length) {
          data.forEach((row) => {
            this.totalCount += row.qtt;
            this.totalPrice += (row.nabavna * row.qtt);
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          alert(error); // eslint-disable-line
        }
      }
    },
    async addVirtual() {
      if (!this.newVirtual.sku || !this.newVirtual.nabavna || !this.newVirtual.prodajna || !this.newVirtual.qtt) {
        return;
      }

      if (this.newVirtual.nabavna > this.newVirtual.prodajna) {
        return;
      }
      try {
        await axios.post(`${fixed.API_URL}/admin/add-virtual`, this.newVirtual, { withCredentials: true });
        this.newVirtual = {};
        await this.getVirtuals();
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for this action ✋🏻'); // eslint-disable-line
        } else {
          alert(error); // eslint-disable-line
        }
      }
    },
    async sellAllVirtuals() {
      const sell = confirm(`Export all as sold, sure?`); // eslint-disable-line
      if (!sell) return;

      this.loading = true;
      try {
        // iterate over articles and sell each
        this.virtuals.forEach(async (virtual) => {
          const { sku, qtt } = virtual;
          await axios.put(`${fixed.API_URL}/admin/virtual`, { sku, qtt }, { withCredentials: true });
        });
        // After all done fetch the try to fetch the list again to see if there are any leftovers
        await this.getVirtuals();
      } catch (err) {
        alert(err); // eslint-disable-line
      }
      this.loading = false;
    },
    async sellVirtual(v) {
      const { sku, qtt } = v;
      const prodaj = confirm(`Skini ${sku} sa stanja i zabiljezi prodaju?`); // eslint-disable-line
      if (!prodaj) return;

      try {
        await axios.put(`${fixed.API_URL}/admin/virtual`, { sku, qtt }, { withCredentials: true });
        this.$bvModal.show('success');
        await this.getVirtuals();
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for this action ✋🏻'); // eslint-disable-line
        } else {
          alert(error); // eslint-disable-line
        }
      }
    },
    async returnVirtual(v) {
      const { sku } = v;
      const vrati = confirm(`Vrati ${sku} na stanje i obrisi virtual artikal?`); // eslint-disable-line
      if (!vrati) return;

      try {
        await axios.post(`${fixed.API_URL}/admin/return-virtual`, v, { withCredentials: true });
        this.$bvModal.show('success');
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          alert(error); // eslint-disable-line
        }
      }
      await this.getVirtuals();
    },
  },
};
</script>
